import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { OmniChatFacade } from '@cigna/omni/chat-state-data-access';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state-data-access';

@Component({
  selector: 'cigna-omni-splash-close-screen',
  templateUrl: './chat-splash-close-screen.component.html',
  styleUrls: ['./chat-splash-close-screen.component.scss'],
})
export class OmniMessagingSplashCloseScreenComponent implements AfterViewInit {
  @Input() public screenText: string;
  @Input() public conversationId: string;
  @ViewChild('textRef', { static: true })
  public textRef: ElementRef;

  constructor(
    private omniChatFacade: OmniChatFacade,
    private cnvFacade: OmniConversationsFacade,
  ) {}

  public endChat() {
    this.omniChatFacade.closeDialog();
    this.cnvFacade.endConversation(this.conversationId);

    setTimeout(() => {
      this.focusChatBubble();
    }, 300);
  }

  public keepChat() {
    this.cnvFacade.setCloseSplashScreen(false);
  }

  ngAfterViewInit() {
    this.textRef.nativeElement.focus();
  }

  private focusChatBubble(): void {
    const ariaLabel = 'aria-label';
    const chatBubbleButton = document.querySelector(
      '.conv-chat-bubble-button-expander, .conv-chat-bubble-button',
    ) as HTMLElement | null;

    if (chatBubbleButton) {
      chatBubbleButton.focus();

      const originalAriaLabel = chatBubbleButton.getAttribute(ariaLabel);
      chatBubbleButton.setAttribute(ariaLabel, 'Chat with us button');

      this.announceToScreenReader(
        'Chat has ended. Chat with us button is now available.',
      );

      setTimeout(() => {
        if (originalAriaLabel) {
          chatBubbleButton.setAttribute(ariaLabel, originalAriaLabel);
        }
      }, 1500);
    }
  }

  private announceToScreenReader(message: string): void {
    let liveRegion = document.getElementById('chat-status-announcer');

    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'chat-status-announcer';
      liveRegion.className = 'sr-only';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = '';

    setTimeout(() => {
      if (liveRegion) {
        liveRegion.textContent = message;

        setTimeout(() => {
          if (liveRegion) {
            liveRegion.textContent = '';
          }
        }, 1500);
      }
    }, 100);
  }
}
